import * as React from "react";

import SaveChangesPng from "./SaveChanges.png";

export const SaveChanges = () => {
  return (
    <img
      id="save-changes"
      src={SaveChangesPng}
      alt="Save Changes"
      draggable="false"
      style={{ height: "100%", width: "auto", objectFit: "contain" }}
    />
  );
};
